import React from 'react';
import CIcon from '@coreui/icons-react';
import { CRow, CCol } from '@coreui/react';
import { getUtcFormattedDate } from 'utils/dates';
import './CareHomeUserSubscriptionDetails.scss';

const CareHomeUserSubscriptionDetails = ({ user }) => {
    const subscription = user?.subscriptions?.[0];

    if (!subscription) return null;

    const {
        thrivers = 0,
        linkedThrivers = 0,
        start,
        currentPeriodEnd,
    } = subscription;

    const remaining = thrivers - linkedThrivers;

    return (
        <div className="carehome-subscription-details mt-4">
            <h5 className="mb-3 font-weight-bold">
                Subscription Details
            </h5>

            <CRow className="subscription-cards-row">

                {/* Purchased */}
                <CCol className="subscription-col">
                    <div className="subscription-card pink-card">
                        <div className="icon-circle">
                            <CIcon name="cil-shield-alt" />
                        </div>
                        <div className="card-info">
                            <span className="label">THRIVER LICENSE PURCHASED</span>
                            <span className="value">{thrivers}</span>
                        </div>
                    </div>
                </CCol>

                {/* Consumed */}
                <CCol className="subscription-col">
                    <div className="subscription-card blue-card">
                        <div className="icon-circle">
                            <CIcon name="cil-sync" />
                        </div>
                        <div className="card-info">
                            <span className="label">THRIVER LICENSE CONSUMED</span>
                            <span className="value">
                                {linkedThrivers}
                                <span className="total-label"> / {thrivers}</span>
                            </span>
                        </div>
                    </div>
                </CCol>

                {/* Remaining */}
                <CCol className="subscription-col">
                    <div className="subscription-card green-card">
                        <div className="icon-circle">
                            <CIcon name="cil-check-circle" />
                        </div>
                        <div className="card-info">
                            <span className="label">THRIVER LICENSE REMAINING</span>
                            <span className="value">{remaining}</span>
                        </div>
                    </div>
                </CCol>

                {/* Start Date */}
                <CCol className="subscription-col">
                    <div className="subscription-card gray-card">
                        <div className="icon-circle">
                            <CIcon name="cil-calendar" />
                        </div>
                        <div className="card-info">
                            <span className="label">SUBSCRIPTION START DATE</span>
                            <span className="value date-value">
                                {getUtcFormattedDate(start)}
                            </span>
                        </div>
                    </div>
                </CCol>

                {/* Expiry Date */}
                <CCol className="subscription-col">
                    <div className="subscription-card gray-card">
                        <div className="icon-circle">
                            <CIcon name="cil-calendar" />
                        </div>
                        <div className="card-info">
                            <span className="label">SUBSCRIPTION EXPIRY DATE</span>
                            <span className="value date-value">
                                {getUtcFormattedDate(currentPeriodEnd)}
                            </span>
                        </div>
                    </div>
                </CCol>

            </CRow>
        </div>
    );
};

export default CareHomeUserSubscriptionDetails;